import { render } from "./TagField.vue?vue&type=template&id=4fc3d782&scoped=true"
import script from "./TagField.vue?vue&type=script&lang=js"
export * from "./TagField.vue?vue&type=script&lang=js"

import "./TagField.vue?vue&type=style&index=0&id=4fc3d782&scoped=true&lang=css"

import exportComponent from "/Users/shuaqq/Desktop/quickadmin/vue3/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc3d782"]])

export default __exports__